/**
 * Formats a stored API identifier for display by separating word boundaries.
 * The canonical API name in CMS is unchanged.
 */
export function formatApiDisplayName(name: string): string {
  const trimmed = name?.trim() ?? "";
  if (!trimmed) return trimmed;
  if (/\s/.test(trimmed)) return trimmed;

  return trimmed
    .replace(/_/g, " ")
    .replace(/-/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();
}
